const googlebotUserAgentRegex = /Googlebot/;

const isSeo = (): boolean =>
  navigator.userAgent.match(googlebotUserAgentRegex) !== null;

export default isSeo;
